import React, { forwardRef } from 'react';
import { StyledLayout } from './index.styles.js';
export const Layout = forwardRef(({ className, margin, padding, 'data-testid': dataTestId, children, align, direction, justify, wrap, rowGap, columnGap, role, as }, ref) => {
    return (React.createElement(StyledLayout, { role: role, ref: ref, flexAlign: align, flexDirection: direction, flexJustify: justify, flexWrap: wrap, className: className, "data-testid": dataTestId, margin: margin, padding: padding, rowGap: rowGap, columnGap: columnGap, as: as }, children));
});
Layout.displayName = 'Layout';
//# sourceMappingURL=index.js.map